import React from "react";
import { SearchBox } from "components/helpers/searchBox/SearchBox";
import { TableInfo } from "api";

export type PageHeaderProps = {
  pageTitle: string;
  table: TableInfo;
  changeSearch?(searchString: string): void;
  initialSearchString: string;
  addButtonText: string;
  onAddButtonClick?(): void;
  onOpenFilters?: any;
};

const PageHeader: React.FC<PageHeaderProps> = ({
  pageTitle,
  table,
  changeSearch,
  initialSearchString,
  addButtonText,
  onAddButtonClick,
}) => {
  return (
    <div className="PageHeader">
      <h1 style={{ marginBottom: "0" }}>{pageTitle}</h1>
      <div className="HeaderActionsContainer">
        {(table?.data?.details as any).bHasSearchField && (
          <SearchBox
            key={initialSearchString}
            changeSearch={changeSearch}
            initialSearchString={initialSearchString}
            goToPage={table.data?.actions.goToPage}
          />
        )}
        <div className="Buttons">
          {onAddButtonClick && (
            <button className="Btn BtnAdd" onClick={onAddButtonClick}>
              {addButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export { PageHeader };
